/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MstCalendarCenterSupplierUpdateBase } from './MstCalendarCenterSupplierUpdateBase';
import {
    MstCalendarCenterSupplierUpdateBaseFromJSON,
    MstCalendarCenterSupplierUpdateBaseFromJSONTyped,
    MstCalendarCenterSupplierUpdateBaseToJSON,
    MstCalendarCenterSupplierUpdateBaseToJSONTyped,
} from './MstCalendarCenterSupplierUpdateBase';

/**
 * 
 * @export
 * @interface MstCalendarCenterSupplierUpdate
 */
export interface MstCalendarCenterSupplierUpdate {
    /**
     * 
     * @type {Array<MstCalendarCenterSupplierUpdateBase>}
     * @memberof MstCalendarCenterSupplierUpdate
     */
    body: Array<MstCalendarCenterSupplierUpdateBase>;
}

/**
 * Check if a given object implements the MstCalendarCenterSupplierUpdate interface.
 */
export function instanceOfMstCalendarCenterSupplierUpdate(value: object): value is MstCalendarCenterSupplierUpdate {
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function MstCalendarCenterSupplierUpdateFromJSON(json: any): MstCalendarCenterSupplierUpdate {
    return MstCalendarCenterSupplierUpdateFromJSONTyped(json, false);
}

export function MstCalendarCenterSupplierUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstCalendarCenterSupplierUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'body': ((json['body'] as Array<any>).map(MstCalendarCenterSupplierUpdateBaseFromJSON)),
    };
}

export function MstCalendarCenterSupplierUpdateToJSON(json: any): MstCalendarCenterSupplierUpdate {
    return MstCalendarCenterSupplierUpdateToJSONTyped(json, false);
}

export function MstCalendarCenterSupplierUpdateToJSONTyped(value?: MstCalendarCenterSupplierUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': ((value['body'] as Array<any>).map(MstCalendarCenterSupplierUpdateBaseToJSON)),
    };
}

